module.exports = __webpack_public_path__ + "img/blue_bay_extra_room.5e63c2c5.jpeg";